import { takeLatest, put, call, delay, select } from "redux-saga/effects";
import axios from "../../utils/axios";
import log from "loglevel";

import { requestDefaultJson } from './helpers'
import getEnvParam from "../../utils/getEnvParam";
import { Creators as actionsConciliationResult } from '../ducks/conciliationResult'

const reconcileFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

const reconcileTaxFromApi = (id, file, token) => {
	return requestDefaultJson({
		URIComplete: getEnvParam('REACT_APP_BFF_URL_REST')+ '/conciliacaofiscal/emiteRFM',
		method: 'POST',
		headers: {
			NPF_ROUTE: getEnvParam('REACT_APP_HEADER_CONCILIACAO_FISCAL'),
			"Authorization": token
		},
		data: {
			id,
			nFeBase64: file
		}
	});
}

function* tradeConciliation(payload, token) {
	try {
		const { orderId, file } = payload;

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/graphql",
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CONCILIACAO_COMERCIAL"),
				"Authorization": token
			},
			data: `mutation {
					conciliacaoComercial(id: "${orderId}", file: "${file.result}") {
						id
						statusConciliacaoComercial {
							id
							descricao
						}
					}
				}`
		};

		const { data } = yield call(reconcileFromApi, options);

		const tradeStatus = data 
													&& data.conciliacaoComercial 
													&& data.conciliacaoComercial.statusConciliacaoComercial
													&& parseInt(data.conciliacaoComercial.statusConciliacaoComercial.id) === 2 ? true : false;

		yield put({
			type: "TRADE_CONCILIATION",
			payload: tradeStatus
		});

		let result = { status: tradeStatus }

		return result
	} catch (error) {
		yield put({
			type: "TRADE_CONCILIATION",
			payload: false
		});
		log.info(error);
	}
}

function* taxConciliation(payload, token) {
	const { orderId, file:{ result } } = payload;
	try {
		const data = yield call(reconcileTaxFromApi, orderId, result, token);

		yield delay(4000);
		yield put({
			type: "TAX_CONCILIATION",
			payload: data
		});

	} catch (error) {
		yield put({
			type: "TAX_CONCILIATION",
			payload: { status: false } 
		});
		log.info(error);
	}
}

function* conciliation(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		yield put(actionsConciliationResult.conciliationResultLoading(true));

		yield delay(2000);
		const tradeResult = yield call(tradeConciliation, payload, token);

		if (tradeResult.status === true) {
			yield call(taxConciliation, payload, token);
		}


	} catch (error) {
		//TODO Este bloco em producao deverah ser melhor tratado e
		//apresentar uma mensagem para o cliente
		log.info(error);
	} finally {
        yield put(actionsConciliationResult.conciliationResultLoading(false));
    }
}

// //Generator function
export function* reconcileWatcher() {
	yield takeLatest("CONCILIATION_REQUEST", conciliation);
}
